import { useState, useContext } from "react";
import { RequestLoader, ToastContext } from "../../../../hooks/context";
import {
  cleanObject,
  getRandomIntInclusive,
  parseDob,
  buildDob,
} from "../../../../helpers";
import { useSelector } from "react-redux";
import countriesStatesList from "../../../../localdata/worldCountryAndState.json";
import citiesList from "../../../../localdata/worldCities.json";
import {
  useCreateCustomerMutation,
  useEditCustomerMutation,
} from "../../../../hooks/api/mutations/useCustomer";

export { parseDob, buildDob };

export const useCustomerForm = ({
  customerInfo,
  isEditMode = false,
  closeModal = () => {},
}) => {
  const { business_phone_code } = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );
  const { setRequestLoaderProgress } = useContext(RequestLoader);
  const triggerToast = useContext(ToastContext);
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const [formData, setFormData] = useState({
    first_name: customerInfo?.first_name || "",
    last_name: customerInfo?.last_name || "",
    phone_number: customerInfo?.phone || "",
    phone_code: customerInfo?.phone_code || business_phone_code || "",
    email: customerInfo?.email || "",
    country: customerInfo?.country || "",
    ...parseDob(customerInfo?.date_of_birth),
    state: customerInfo?.state || "",
    city: customerInfo?.city,
    store_id: customerInfo?.store?.id || "",
    is_loyalty_eligible: customerInfo?.is_loyalty_eligible ?? false,
    gender: customerInfo?.gender || "",
  });

  const { mutate: createCustomer, isLoading: isCreatingCustomer } =
    useCreateCustomerMutation();
  const { mutate: updateCustomer, isLoading: isUpdatingCustomer } =
    useEditCustomerMutation({ id: customerInfo?.id });

  const handleAddCustomer = () => {
    setRequestLoaderProgress(getRandomIntInclusive(10, 50));
    const data = cleanObject(buildDob({ ...formData }));
    createCustomer(data, {
      onSuccess: () => {
        triggerToast("Customer added successfully", "success");
        closeModal();
      },

      onSettled: () => setRequestLoaderProgress(100),
    });
  };

  // update customer properties
  const handleEditCustomer = () => {
    setRequestLoaderProgress(getRandomIntInclusive(10, 50));
    const data = cleanObject(buildDob({ ...formData }));
    updateCustomer(
      { id: customerInfo?.id, data },
      {
        onSuccess: () => {
          triggerToast("Customer updated successfully", "success");
          closeModal();
        },

        onSettled: () => setRequestLoaderProgress(100),
      },
    );
  };

  const handleCustomer = () => {
    if (isEditMode) return handleEditCustomer();
    handleAddCustomer();
  };

  return {
    isLoading: isCreatingCustomer || isUpdatingCustomer,
    citiesList,
    stateList:
      countriesStatesList.find((item) => item?.name === formData?.country)
        ?.states || [],
    countriesStatesList,
    formData,
    storeList,
    handleCustomer,
    setFormData,
  };
};
